import { ReactElement } from "react";
import { Skeleton } from "@mui/material";
import { IContentAreaProps } from "../types";

const SkeletonView = ({ parentSize }: IContentAreaProps): ReactElement => {

  const layout = {
    display: "grid",
    height: parentSize.height - 52,
    gridTemplateColumns: "1fr 1fr 1fr",
    gridTemplateRows: "auto auto 1fr",
    gridGap: "15px"
  };

  return (
    <div style={layout}>
      <Skeleton variant="rectangular" height={100} />
      <Skeleton variant="rectangular" height={100} />
      <Skeleton variant="rectangular" height={100} />

      <Skeleton variant="rectangular" height={100} sx={{
        gridColumn: "1 / span 3",
        gridRow: "2 / span 1",
      }}/>

      <Skeleton variant="rectangular"  sx={{
        gridColumn: "1 / span 3",
        gridRow: "3 / span 1",
        height: "100%"
      }}/>
    </div>
  );
};

export default SkeletonView;
